import { uuid } from './../utilities/string';

/**
 * Address model. Encapsulating specific fields required by /address APIs.
 */
export default class Address {
    constructor(values) {
        const { id, ref_id, ref_type, name, kind, street, street2, city, state, zip, country } = values;

        this.id = id;
        this.ref_id = ref_id;
        this.ref_type = ref_type;
        this.kind = kind ? kind : 'l';
        this.name = name ? name : uuid();
        this.street = street;
        this.street2 = street2;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.country = country || 'US';
    }
}



// WEBPACK FOOTER //
// ./src/models/address.jsx